module.exports = __webpack_public_path__ + "static/img/mirror_mini.a8f5f7de.png";